import store from 'app/store';
import authRoles from 'app/auth/authRoles';
import { FuseLoadable } from '@fuse';

const ListAdminAppConfig = {
    auth: authRoles.everyoneButGuest,
    routes: [
        {
            path: '/manage/sub-users',
            component: FuseLoadable({ loader: () => import('./ManageSubUserApp') }),
        },
        {
            path: '/manage/link-users',
            component: FuseLoadable({ loader: () => import('./AdminLinkedUserApp') }),
        },
        {
            path: '/manage/create-link-user',
            component: FuseLoadable({ loader: () => import('../create/CreateMultisiteUserLinkApp') }),
        },
    ],
};

export default [ListAdminAppConfig];
